// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigation {
    width: 280px;
    height: 100vh;
    background: #00172F;
    position: fixed;
}

.Navigation_header {
    height: 64px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 12px 0px 8px 12px;
    background: #00172F;
}

.Navigation_header_img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px;
    width: 40px;
    height: 38px;
    background: #007CB0;
    border-radius: 2px 2px 0px 0px;
    margin-right: 8px;
}

.Navigation_header_text {
    margin-top: 15px;
    width: 49px;
    height: 24px;
    font-family: 'Gibson-regular';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
}


.Navigation_img {
    margin-right: 24px;
}

.leftnav .MuiAccordionSummary-content div:nth-child(2) {
    margin-top: 7px !important;
}

.Navigation_lowerlinks {
    position: absolute;
    bottom: 0
}

.leftnav .MuiAccordionSummary-content {
    display: inline-flex !important;
}

.leftnav .MuiGrid-container {
    font-family: 'Gibson-Regular' !important;
}

.projecticon_img {
    cursor: pointer;
}

.container {
    text-align: center;
    margin-top: 300px;
}

.logo {
    width: 100px;
    margin-bottom: 20px;
}

.typographyHeading {
    margin-bottom: 20px;
}

.typographyBody {
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".Navigation {\n    width: 280px;\n    height: 100vh;\n    background: #00172F;\n    position: fixed;\n}\n\n.Navigation_header {\n    height: 64px;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 12px 0px 8px 12px;\n    background: #00172F;\n}\n\n.Navigation_header_img {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 8px;\n    width: 40px;\n    height: 38px;\n    background: #007CB0;\n    border-radius: 2px 2px 0px 0px;\n    margin-right: 8px;\n}\n\n.Navigation_header_text {\n    margin-top: 15px;\n    width: 49px;\n    height: 24px;\n    font-family: 'Gibson-regular';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #FFFFFF;\n}\n\n\n.Navigation_img {\n    margin-right: 24px;\n}\n\n.leftnav .MuiAccordionSummary-content div:nth-child(2) {\n    margin-top: 7px !important;\n}\n\n.Navigation_lowerlinks {\n    position: absolute;\n    bottom: 0\n}\n\n.leftnav .MuiAccordionSummary-content {\n    display: inline-flex !important;\n}\n\n.leftnav .MuiGrid-container {\n    font-family: 'Gibson-Regular' !important;\n}\n\n.projecticon_img {\n    cursor: pointer;\n}\n\n.container {\n    text-align: center;\n    margin-top: 300px;\n}\n\n.logo {\n    width: 100px;\n    margin-bottom: 20px;\n}\n\n.typographyHeading {\n    margin-bottom: 20px;\n}\n\n.typographyBody {\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
